import { searchGroupMembers } from 'src/models/group/group';
import { Identifier } from 'src/types/utilityTypes';
import api from 'src/utils/ajax';

export interface MentionSearchUser {
  id: Identifier;
  name: string;
  avatar?: string;
}

interface SmSearchUserRow {
  id: Identifier;
  term: string;
  data?: { json?: { image?: string } };
}

/**
 * User autocomplete for @mentions (same /sm/search contract as v2 mentions-text-area.js).
 */
export const searchMentionableUsers = async ({
  term,
  trainerId,
  signal,
}: {
  term: string;
  trainerId: Identifier | null | undefined;
  signal?: AbortSignal;
}): Promise<MentionSearchUser[]> => {
  if (trainerId === null || trainerId === undefined || trainerId === '') {
    return [];
  }
  const type = `user_white_label_${trainerId}`;
  const { data } = await api.get<{ results: Record<string, SmSearchUserRow[]> }>(
    '/sm/search',
    {
      params: {
        types: [type],
        term,
        limit: 10,
        no_limit: false,
        page: 1,
      },
      signal,
    }
  );

  const rows = data.results[type] ?? [];
  return rows.map((r) => ({
    id: r.id,
    name: r.term,
    avatar: r.data?.json?.image,
  }));
};

/**
 * @mention autocomplete limited to members of a group (group discussion / group activity).
 */
export const searchMentionableGroupMembers = async ({
  groupId,
  term,
  signal,
}: {
  groupId: Identifier | null | undefined;
  term: string;
  signal?: AbortSignal;
}): Promise<MentionSearchUser[]> => {
  if (groupId === null || groupId === undefined || groupId === '') {
    return [];
  }
  const typeKey = `group_members_${groupId}`;
  const rows = await searchGroupMembers({
    search: term,
    types: [typeKey],
    signal,
  });
  return rows.map((r) => ({
    id: r.id,
    name: r.name,
    avatar: r.image || undefined,
  }));
};
